module.exports = __webpack_public_path__ + "media/application/images/gold1-5a90bed13916c705ffd727eee3e8cea6.png";